import { useNavigate } from 'react-router-dom';

import { usePayableDetail } from '../../hooks/usePayableDetail';
import { useBasePurchase } from '../../../../../hooks/purchases/useBasePurchase';
import { usePayablePdf } from '../../../../../hooks/pdf/usePayablePdf';

import { detailActions } from '../../config/detailActions.config';

const DetailActionsSection = () => {
  const navigate = useNavigate();

  const { detail } = usePayableDetail();

  const { handlerViewPurchaseById } = useBasePurchase();

  const { handleDownloadPayablePdf } = usePayablePdf();

  /**
   * 🛒 Ver compra origen
   */
  const handleViewPurchaseOrigin = () => {
    const origin = detail?.origin;
    const purchaseId = Number(origin?.referenceNumber);

    if (!purchaseId || origin?.type === 'MANUAL') return;

    if (origin.type === 'RESTAURANT_RAW_MATERIAL_PURCHASE') {
      navigate(`/restaurant/inventory/purchases?purchaseId=${purchaseId}`);
      return;
    }

    if (origin.type === 'PURCHASE') {
      handlerViewPurchaseById(purchaseId);
    }
  };

  /**
   * 💰 Registrar pago
   */
  const handleRegisterPayment = () => {
    if (!detail) return;

    navigate(`/finance/cxp/register-payment/${detail.id}`);
  };

  /**
   * 📄 Estado de cuenta PDF
   */
  const handleAccountStatement = () => {
    if (!detail) return;

    handleDownloadPayablePdf(detail.id);
  };

  /**
   * 📧 Recordatorio
   */
  const handleSendReminder = () => {
    console.log('Enviar recordatorio');
  };

  const handleActionClick = (actionKey: string) => {
    switch (actionKey) {
      case 'view-purchase-origin':
        handleViewPurchaseOrigin();
        break;

      case 'register-payment':
        handleRegisterPayment();
        break;

      case 'account-status':
        handleAccountStatement();
        break;

      case 'send-reminder':
        handleSendReminder();
        break;

      default:
        break;
    }
  };

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Acciones rápidas
      </h4>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {detailActions.map((action) => {
          const Icon = action.icon;

          /**
           * 🔥 Solo habilitar si existe compra origen
           */
          const isPurchaseAction = action.key === 'view-purchase-origin';

          const disabled =
            isPurchaseAction &&
            (!Number(detail?.origin?.referenceNumber) ||
              detail?.origin?.type === 'MANUAL');

          return (
            <button
              key={action.key}
              type="button"
              disabled={disabled}
              onClick={() => handleActionClick(action.key)}
              className={`
                group
                flex flex-col items-center justify-center
                gap-3
                rounded-xl
                border
                px-5
                py-4
                text-center
                font-medium
                transition-all
                duration-200
                ${
                  disabled ? 'cursor-not-allowed opacity-50' : 'hover:shadow-sm'
                }
                ${action.variant}
                ${action.featured ? 'scale-[1.01]' : ''}
              `}
            >
              <div
                className="
                  flex h-11 w-11 items-center justify-center
                  rounded-full
                  bg-white
                  shadow-sm
                  dark:bg-boxdark-2
                "
              >
                <Icon size={21} />
              </div>

              <span className="text-sm font-semibold leading-tight">
                {action.title}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default DetailActionsSection;
